const MODAL_DOCK_STORAGE_KEY = "flownect:minimized-modal-dock:v1";

const removeDockItemsFromStorage = (storage) => {
  if (!storage) return;

  Object.keys(storage)
    .filter((key) => key === MODAL_DOCK_STORAGE_KEY || key.startsWith(`${MODAL_DOCK_STORAGE_KEY}:`))
    .forEach((key) => storage.removeItem(key));
};

export const clearModalDockStorage = () => {
  if (typeof window === "undefined") return;

  removeDockItemsFromStorage(window.localStorage);
  removeDockItemsFromStorage(window.sessionStorage);
};
